import {LineupsMemberSeasonStatsApiModel} from "./lineups-member.season-stats.api-model";
import {EntityDomainModel} from "../../../../../infrastructure/models/entity/entity.domain-model";

export class LineupsMemberSeasonStatsDomainModel extends EntityDomainModel {
  apiModel: LineupsMemberSeasonStatsApiModel;

  get type(): Number {
    return this.apiModel.type;
  }

  get text(): String {
    return this.apiModel.text;
  }

  get isSignificant(): Boolean {
    return this.apiModel.isSignificant;
  }

  get color(): String {
    return this.apiModel.color;
  }
}
